'use strict';

var toastr = require('toastr');
var _ = require('lodash');
var optWeekService = function optWeekService(configurationService, momentService, $filter, $log) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var calculateLastDayOfWeek = function calculateLastDayOfWeek() {
    var lastROMDate = momentService.of(configurationService.getLastROMDate(), momentService.FIELD.OPT_GROUP_DATE);
    var lastDayOfWeek = lastROMDate.setDay(configurationService.getROMWeekEndDOW());
    return lastDayOfWeek.isAfter(lastROMDate) ? lastDayOfWeek.subtract(7, 'day') : lastDayOfWeek;
  };
  var getOptWeekData = function getOptWeekData(conf, flattened) {
    var variations = {
      'ROM summary': 'getROMMaxRangeSummaryWeeks',
      'ROM analysis': 'getROMMaxRangeAnalysisWeeks',
      'ROM reference': 'getROMMaxReferenceWeeks',
      'Default': 'getROMMaxRangeSummaryWeeks'
    };
    var mode = variations[conf] || variations.Default;
    var MaxRangeSummaryWeeks = configurationService[mode]();
    var subtractedDay = calculateLastDayOfWeek();
    var optWeeks = [];
    while (MaxRangeSummaryWeeks > 0) {
      var value = rmMomentFormat(subtractedDay, 'DATE_ISO');
      var optWeek = flattened ? value : {
        value: value,
        dropdownVisibleValue: rmMomentFormat(subtractedDay, 'MONTH_DAY'),
        toString: subtractedDay.toString.bind(subtractedDay)
      };
      optWeeks.push(optWeek);
      subtractedDay = subtractedDay.subtract(7, 'day');
      MaxRangeSummaryWeeks--;
    }
    return optWeeks;
  };
  var getFlattenedOptWeekData = function getFlattenedOptWeekData(conf) {
    var flattened = true;
    return getOptWeekData(conf, flattened);
  };
  var getDaysOfWeek = function getDaysOfWeek(endingWith, full) {
    endingWith = endingWith || configurationService.getROMWeekEndDOW();
    var format = full ? 'FULL_DAY_OF_WEEK' : 'DAY_OF_WEEK';
    var daysOfWeek = [];
    var currentDay = momentService.of(0, momentService.FIELD.OPT_GROUP_DATE);
    currentDay = currentDay.setDay(endingWith);
    for (var day = 0; day < 7; day++) {
      currentDay = currentDay.add(1, 'day');
      daysOfWeek.push(rmMomentFormat(currentDay, format));
    }
    return daysOfWeek;
  };
  var getIndexOfDayOfWeek = function getIndexOfDayOfWeek(dayOfWeek) {
    var result;
    dayOfWeek = dayOfWeek || '';
    if (_.includes(dayOfWeek, ',')) {
      result = 1;
    } else {
      var full = dayOfWeek.length > 3;
      result = getDaysOfWeek(false, full).map(function (element) {
        return element.toUpperCase();
      }).indexOf(dayOfWeek.toUpperCase());
    }
    if (result === -1) {
      $log.error('Incorrect format of day of week: ' + dayOfWeek);
      toastr.error('Incorrect format of day of week: ' + dayOfWeek);
    }
    return result;
  };
  return {
    getOptWeekData: getOptWeekData,
    getFlattenedOptWeekData: getFlattenedOptWeekData,
    getDaysOfWeek: getDaysOfWeek,
    getIndexOfDayOfWeek: getIndexOfDayOfWeek
  };
};
optWeekService.$inject = ['ConfigurationService', 'MomentService', '$filter', '$log'];
module.exports = optWeekService;